<h2>{{ 'new_antrag.stepper.label.third_step.head.title' | translate }}</h2>
<p
  [innerHTML]="'new_antrag.stepper.label.third_step.head.description' | translate | bypassSecurityPipe: 'html'"
  class="translation-text"></p>
<mat-card appearance="outlined" tabindex="-1">
  <mat-card-content>
    <p class="loading">
      {{ 'waiting_text.uploading' | translate: progressParams() }}
    </p>
    <section class="progress-section">
      <mat-progress-bar [value]="(uploadedSeiten() * 100) / allPages()" mode="buffer" />
    </section>
  </mat-card-content>
  @if (uploadHasErrored()) {
    <mat-card-actions class="mat-card-action-row">
      <button (click)="startUpload()" color="primary" mat-flat-button>
        {{ 'general.label.reload.try_again' | translate }}
      </button>
      <button (click)="discardAntrag()" color="warn" mat-flat-button>
        {{ 'new_antrag.button.discard_antrag' | translate }}
      </button>
    </mat-card-actions>
  }
</mat-card>
